import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames/bind";
import styles from "./AdminDashboardPage.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { ToastContext } from "~/components/context/ToastContext";
import { ModalContext } from "~/components/context/ModalContext";
import { BASE_TRANSACTIONS_URL } from '~/helper/apiService';

const cx = classNames.bind(styles);

function TransactionHistory() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { showToast } = useContext(ToastContext);
  const { showModal } = useContext(ModalContext);

  const fetchTransactions = async () => {
    try {
      const response = await fetch(
        `${BASE_TRANSACTIONS_URL}get-all-transactions`,
        {
          credentials: "include",
        }
      );
      const data = await response.json();
      if (response.ok) {
        setTransactions(data.transactions);
        setLoading(false);
      } else {
        showToast(data.error || "Lỗi khi lấy dữ liệu giao dịch", "error");
        setLoading(false);
      }
    } catch (error) {
      showToast("Lỗi kết nối: " + error.message, "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const handleDelete = async (timestamp, phone) => {
    try {
      const response = await fetch(
        `${BASE_TRANSACTIONS_URL}delete-transaction?timestamp=${encodeURIComponent(timestamp)}&phone=${encodeURIComponent(phone)}`,
        {
          method: "DELETE",
          credentials: "include",
        }
      );
      const data = await response.json();
      if (response.ok) {
        showToast("Xóa giao dịch thành công", "success");
        await fetchTransactions();
      } else {
        showToast(data.error || "Lỗi khi xóa giao dịch", "error");
        return false; // Keep modal open on error
      }
    } catch (error) {
      showToast("Lỗi kết nối: " + error.message, "error");
      return false; // Keep modal open on error
    }
  };

  const confirmDelete = (timestamp, phone) => {
    showModal({
      title: "Xác Nhận Xóa",
      message: `Bạn có chắc chắn muốn xóa giao dịch lúc ${timestamp} cho số điện thoại ${phone}?`,
      onConfirm: () => handleDelete(timestamp, phone),
      onCancel: null, // Uses default hideModal from ModalContext
    });
  };

  return (
    <div className={cx("transactions-section")}>
      <h2 className={cx("subtitle")}>Lịch Sử Giao Dịch</h2>
      {loading ? (
        <p className={cx("loading")}>Đang tải dữ liệu...</p>
      ) : transactions.length === 0 ? (
        <p className={cx("no-data")}>Không có giao dịch nào</p>
      ) : (
        <table className={cx("table")}>
          <thead>
            <tr>
              <th className={cx("th")}>Thời Gian</th>
              <th className={cx("th")}>Số Điện Thoại</th>
              <th className={cx("th")}>Điểm</th>
              <th className={cx("th")}>Hành Động</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction, index) => (
              <tr key={index} className={cx("tr")}>
                <td className={cx("td")}>{transaction.timestamp}</td>
                <td className={cx("td")}>{transaction.phone}</td>
                <td
                  className={cx("td", {
                    positive: transaction.points > 0,
                    negative: transaction.points < 0,
                  })}
                >
                  {transaction.points}
                </td>
                <td className={cx("td")}>
                  <div className={cx("button-container")}>
                    <button
                      className={cx("delete-button")}
                      onClick={() =>
                        confirmDelete(transaction.timestamp, transaction.phone)
                      }
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default TransactionHistory;
